import { useApi } from '~/composables/common/use-api'
import { useUserBanksStore } from '~/stores/user-banks.store.ts'
import { TRANSACTION_API } from '~/configs/api'
import type { UserBankItem } from '~/composables/account/interface'
import { ResponseStatus } from '~composables/common/interface'

export function useMainBank() {
  const { request } = useApi()
  const storeBanks = useUserBanksStore()
  const isLoading = ref(false)
  const userBanks = computed(() => {
    return storeBanks?.userMainBanks ?? []
  })
  async function fetchUserMainBanks(server: boolean = false): Promise<void> {
    isLoading.value = true
    try {
      const { data, status } = await request(TRANSACTION_API.USER_BANKS, {
        method: 'GET',
        server
      })
      if (status === ResponseStatus.OK) {
        const userMainBank = data?.filter(
          (item: UserBankItem) => !item.is_disable && item.bank_code && item.bank_account_name && item.bank_account_no
        )
        storeBanks.setUserMainBank(userMainBank)
      }
    } finally {
      isLoading.value = false
    }
  }

  return { fetchUserMainBanks, userBanks, isLoading }
}
